import { render } from "./UserListPage.vue?vue&type=template&id=0d16d10f&ts=true"
import script from "./UserListPage.vue?vue&type=script&lang=ts"
export * from "./UserListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__